import { NavLink } from "react-router-dom";

const TABS = [["/admin/promos", "Promo codes", "admin-tab-promos"], ["/admin/scene-breaks", "Scene breaks", "admin-tab-scene-breaks"], ["/admin/updates", "Updates", "admin-tab-updates"]];

export const AdminNav = () => (
  <nav className="flex gap-1 rounded-full border border-line p-1 w-fit mb-8" data-testid="admin-nav">
    {TABS.map(([to, l, id]) => (
      <NavLink key={to} to={to} data-testid={id}
        className={({ isActive }) => `rounded-full px-4 py-1.5 text-xs transition-colors ${isActive ? "bg-amber-500 text-onaccent font-semibold" : "text-slate-400 hover:text-slate-200"}`}>{l}</NavLink>
    ))}
  </nav>
);
